import api from "./api";
import moment from 'moment'

const limit = 99999;

export const getPriceLists = async (Dto: {
    page: number;
    q: string;
    from: string;
    to: string;
}) => {

    // Create an object to store non-empty parameters
    const queryParams: Record<string, string> = {};

    // Check and add 'q' parameter if not empty
    if (Dto.q.trim() !== '') {
        queryParams.q = Dto.q.trim();
    }

    // Check and add 'from' parameter if not empty
    if (Dto.from.trim() !== '') {
        queryParams.from = Dto.from.trim();
    }

    // Check and add 'to' parameter if not empty
    if (Dto.to.trim() !== '') {
        queryParams.to = Dto.to.trim();
    }

    // Construct the query string
    const queryString = Object.keys(queryParams)
        .map(key => `${key}=${queryParams[key]}`)
        .join('&');

    // Construct the API request URL with the query string
    const url = `/price-list?limit=${limit}${queryString ? `&${queryString}` : ''}`;

    return await api.get(url);
};

export const duplicatePriceList = async (Dto: {
    priceListId: number;
    name: string;
}) => {
    const url = `/price-list/duplicate?limit=${limit}`;
    return await api.post(url, {
        priceListId: Dto.priceListId,
        name: Dto.name
    });
};

export const postPriceLists = async (Dto: {
    name: string;
    warehouseId: number;
    startDate: string;
    endDate: string;
}) => {
    const url = `/price-list?limit=${limit}`;

    return await api.post(url, {
        name: Dto.name,
        warehouseId: Dto.warehouseId,
        startDate: Dto.startDate,
        endDate: Dto.endDate
    });
};

export const deletePriceList = async (Dto: {
    id: number;
}) => {
    const url = `/price-list`;
    return await api.delete(`${url}/${Dto.id}?limit=${limit}`);
};

export const activatePriceList = async (Dto: {
    id: React.Key[];
}) => {
    const url = `/price-list/active`;
    const currentDateTime = moment().format('MM/DD/YYYY HH:mm:ss');

    return await api.put(`${url}/${Dto.id}?limit=${limit}`, {
        activateOn: currentDateTime
    });
};

export const editPriceList = async (Dto: {
    id: number;
    editedName: string;
    warehouseId: number
}) => {
    const url = `/price-list`;
    return await api.put(`${url}/${Dto.id}?limit=${limit}`, {
        name: Dto.editedName,
        warehouseId: Dto.warehouseId
    });
};

export const getPriceListDetails = async (Dto: {
    id: number;
    page: number;
    q: string;
}) => {

    const queryParams: Record<string, string> = {};

    if (Dto.q.trim() !== '') {
        queryParams.q = Dto.q.trim();
    }

    // Construct the query string
    const queryString = Object.keys(queryParams)
        .map(key => `${key}=${queryParams[key]}`)
        .join('&');

    // Construct the API request URL with the query string
    const url = `/price-list/${Dto.id}?limit=${limit}${queryString ? `&${queryString}` : ''}`;

    return await api.get(url);
};

export const editPriceListDetails = async (Dto: {
    currentPriceListId: number;
    id: number;
    editedPrice: number
}) => {
    const url = `/price-list`;
    return await api.put(`${url}/${Dto.currentPriceListId}/${Dto.id}?limit=${limit}`, {
        newPrice: Dto.editedPrice
    });
};